import React, { createContext, useContext, useState, useEffect } from 'react';

const DarkModeContext = createContext();

export const useDarkMode = () => {
  const context = useContext(DarkModeContext);
  if (!context) {
    throw new Error('useDarkMode must be used within DarkModeProvider');
  }
  return context;
};

export const DarkModeProvider = ({ children }) => {
  // Initialize state from localStorage
  const [darkMode, setDarkMode] = useState(() => {
    if (typeof window === 'undefined') return false; // build-time pre-render: light mode
    try {
      const savedMode = localStorage.getItem('darkMode');
      // Default to false (light mode) if nothing is saved
      return savedMode === null ? false : savedMode === 'true';
    } catch (error) {
      console.error('Error reading darkMode from localStorage:', error);
      return false;
    }
  });

  // index.html hides the pre-rendered (light) page for dark-mode visitors until React has rendered.
  useEffect(() => {
    document.documentElement.classList.remove('cu-dark');
  }, []);

  // Sync to localStorage whenever darkMode changes
  useEffect(() => {
    try {
      localStorage.setItem('darkMode', String(darkMode));
    } catch (error) {
      console.error('Error saving darkMode to localStorage:', error);
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};